import { Injectable } from '@angular/core';
import { IFactory } from '../models/i-factory';

@Injectable({
  providedIn: 'root'
})
export class FactoryService implements IFactory {

  constructor() { }

  create<T>(dataType: { new(): T ; }): T {
    return new dataType();
  }
}
